import {
  AnniProjectProps,
  AnniProjectActionType,
  AnniProjectMessage,
} from './AnniProjectPopupInterface';
import AnniProjectAdmin from './container/AnniProjectAdmin';
import AnniProjectComplete from './container/AnniProjectComplete';
import AnniProjectForm from './container/AnniProjectForm';
import AnniProjectView from './container/AnniProjectView';
import { PopCcontainer, PopupTitle } from '../../Css/Pop';
import Modal from '../../ModalFullSize';
import { Tit } from '../../Titles';
import Button, { BtnClose } from '@/components/Button';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { useUserStore } from '@/stores/UserStore';
import { useLocation } from '@reach/router';
import { navigate } from 'gatsby';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';

const PopContent = styled.div`
  text-align: center;
  overflow-y: auto;
  max-height: calc(100vh - 1.75 * 2rem - 115px);
  margin: 0;

  ${breakpoint(`tablet`)} {
    max-height: calc(100vh - 70px);
    margin: 0;
    padding: 0 20px;
  }
`;

const PopupNoti = styled.div`
  margin: 40px 0;
  text-align: center;
`;

const ButtonContainer = styled.div`
  margin: 40px 0 0 0;
`;
const AnniProjectPopup: FC<AnniProjectProps> = observer(
  ({ onRequestClose, action, id, ...props }) => {
    const userStore = useUserStore();
    const [popupTitle, setPopupTitle] = useState('');
    const [popupWidth, setPopupWidth] = useState('880px');
    const { search } = useLocation();
    const goto = (argAction: AnniProjectActionType, argId: number) => {
      props.goto(argAction, argId);
    };

    useEffect(() => {
      setPopupWidth(
        {
          write: '880px',
          complete: '840px',
          admin: '880px',
          detail: '880px',
        }[action] || '880px',
      );
    }, [action, id]);

    useEffect(() => {
      document.body.style.overflow = props.isOpen ? 'hidden' : 'auto';
    }, [props.isOpen]);

    return (
      <Modal onRequestClose={onRequestClose} maxWidth={popupWidth} {...props}>
        <PopCcontainer css="padding: 0; background-color: #fff;">
          <PopupTitle css="padding: 17px 32px;" className="tit">
            <h2>
              <Tit size="s3" color="sky">
                {
                  {
                    write: `${AnniProjectMessage.DefaultTitle} 만들기`,
                    complete: popupTitle,
                    admin: `${AnniProjectMessage.DefaultTitle} 관리`,
                    detail: popupTitle,
                  }[action]
                }
              </Tit>
            </h2>
            <BtnClose
              onClick={() => onRequestClose()}
              css="right:32px !important;"
            >
              <span className="a11y">닫기</span>
            </BtnClose>
          </PopupTitle>
          <PopContent>
            {action !== AnniProjectActionType.detail &&
            !userStore.isLoggedIn() ? (
              <PopupNoti>
                로그인 후 이용 가능합니다.
                <ButtonContainer>
                  <Button
                    width={350}
                    onClick={() =>
                      navigate(
                        `/auth/login/?redirectTo=/involve/individual/together/${encodeURIComponent(
                          search,
                        )}`,
                      )
                    }
                  >
                    로그인 하러가기
                  </Button>
                </ButtonContainer>
              </PopupNoti>
            ) : (
              <>
                {
                  {
                    // 작성
                    write: (
                      <AnniProjectForm
                        action={action}
                        id={0}
                        isOpen={props.isOpen || false}
                        queryParams=""
                        goto={goto}
                        onRequestClose={onRequestClose}
                      />
                    ),
                    // 작성완료
                    complete: (
                      <AnniProjectComplete
                        action={action}
                        id={id}
                        queryParams=""
                        isOpen={props.isOpen || false}
                        goto={goto}
                        onRequestClose={onRequestClose}
                        setPopupTitle={(tit) => {
                          setPopupTitle(tit);
                        }}
                      />
                    ),
                    // 내 프로젝트 관리
                    admin: (
                      <AnniProjectAdmin
                        action={action}
                        id={id}
                        queryParams=""
                        isOpen={props.isOpen || false}
                        goto={goto}
                        onRequestClose={onRequestClose}
                        setPopupTitle={(tit) => {
                          setPopupTitle(tit);
                        }}
                      />
                    ),
                    // 프로젝트 상세
                    detail: (
                      <AnniProjectView
                        action={action}
                        id={id}
                        queryParams=""
                        isOpen={props.isOpen || false}
                        goto={goto}
                        onRequestClose={onRequestClose}
                        setPopupTitle={(tit) => {
                          setPopupTitle(tit);
                        }}
                      />
                    ),
                  }[action]
                }
              </>
            )}
          </PopContent>
        </PopCcontainer>
      </Modal>
    );
  },
);
export default AnniProjectPopup;
